import { Badge, Statistic, Tabs } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import LeaveRequestTasks from "./leaverequest/LeaveRequestTasks";
import UnassignedLeaveRequestTasks from "./leaverequest/UnassignedLeaveRequestTasks";


export default function () {
    const [assignedData, setAssignedData] = useState({});
    const [unassignedData, setUnassignedData] = useState({});

    useEffect(() => {
        axiosInstance.get("leaveRequest/tasks").then(({ data }) => setAssignedData(data));
        axiosInstance
            .get("leaveRequest/tasks", { params: { unassigned: true } })
            .then(({ data }) => setUnassignedData(data));
    }, []);

    const items = [
      {
        key: '1',
        label: <>Assegnate a me <Badge count={assignedData.count ?? 0}  showZero/></>,
        children: <LeaveRequestTasks/>,
      },
      {
        key: '2',
        label: <>Non assegnate <Badge count={unassignedData.count ?? 0} showZero/></>,
        children: <UnassignedLeaveRequestTasks/>,
      },
    ];
    return (
        <>
            <Tabs items={items}/>
            <div>
            </div>
        </>
    );
}
